var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-group"},_vm._l((_vm.items),function(item,index){return _c('BizCell',{key:index,attrs:{"item":item},on:{"selected":function($event){return _vm.$emit('selected')}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }